import { useState } from "react";
import { supabase } from "../SupabaseClient";
import AnanasLogo from "../images/AnanasSolutionsLogo.webp";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleReset = async () => {
    setLoading(true);
    setErrorMsg("");

    if (!password || !confirm) {
      setErrorMsg("Veuillez entrer un mot de passe.");
      setLoading(false);
      return;
    }

    if (password !== confirm) {
      setErrorMsg("Les mots de passe ne correspondent pas.");
      setLoading(false);
      return;
    }

    // Supabase détecte automatiquement le token dans l'URL (#access_token=...)
    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setErrorMsg(error.message);
    } else {
      setDone(true);
    }

    setLoading(false);
  };

  return (
    <div
      className="text-primary  p-6 rounded-lg mt-6 shadow-lg"
      style={{
        maxWidth: 420,
        margin: "60px auto",
        padding: 20,
        textAlign: "center",
      }}
    >
      {!done ? (
        <>
          <img src={AnanasLogo}></img>
          <div>
            <h1 className="text-xl" style={{ marginBottom: 20 }}>
              Créer un nouveau mot de passe
            </h1>

            <input
              type="password"
              placeholder="Nouveau mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                padding: 12,
                marginBottom: 10,
                borderRadius: 8,
                border: "1px solid #ddd",
              }}
            />

            <input
              type="password"
              placeholder="Confirmer le mot de passe"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              style={{
                width: "100%",
                padding: 12,
                marginBottom: 20,
                borderRadius: 8,
                border: "1px solid #ddd",
              }}
            />

            {errorMsg && (
              <p style={{ color: "red", marginBottom: 10 }}>{errorMsg}</p>
            )}

            <button
              onClick={handleReset}
              disabled={loading}
              style={{
                width: "100%",
                padding: 12,
                background: "#FFD76A",
                color: "#000",
                fontWeight: "bold",
                borderRadius: 8,
                cursor: "pointer",
                border: "none",
              }}
            >
              {loading ? "Patientez..." : "Confirmer"}
            </button>
          </div>
        </>
      ) : (
        <>
          <h2>Mot de passe mis à jour 🎉</h2>
          <p>Vous pouvez maintenant vous connecter.</p>

          <a
            href="/login"
            style={{
              marginTop: 20,
              display: "inline-block",
              background: "#FFD76A",
              color: "#000",
              padding: "10px 20px",
              borderRadius: 8,
              fontWeight: "bold",
              textDecoration: "none",
            }}
          >
            Aller à la connexion
          </a>
        </>
      )}
    </div>
  );
}
